import {dehydrate, QueryClient} from '@tanstack/react-query';

import {disallowSlug, RENDER_MODES} from '@udemy/nextjs-core';

import {PersonalPlanLandingPageFeature} from 'src/features/personal-plan-landing-page';
import {getCompactTranslations} from 'src/lib-server/locale.server';
import {FOUR_HOURS} from 'src/lib/constants';
import {AppContextData} from 'src/types/page-props';

import {getStaticAppContext} from '../api/context.api';

export async function getStaticPaths() {
    return {
        paths: [],
        fallback: 'blocking',
    };
}

export const getStaticProps = disallowSlug(async ({locale}) => {
    locale = locale as string;
    const translations = await getCompactTranslations(locale);
    const client = new QueryClient();

    // Resolve appContext
    const [staticData] = await Promise.all([getStaticAppContext({locale})]);
    const appContext: AppContextData = {
        ...staticData,
        // application specific context can go here
    };

    return {
        props: {
            appContext,
            dehydratedState: dehydrate(client),
            locale,
            pageKey: 'consumer_subscription_landing_page',
            renderMode: RENDER_MODES.ISR, // supports render functions in _document.tsx and _app.tsx.
            translations,
        },
        revalidate: FOUR_HOURS,
    };
});

export default function PersonalPlanLandingPage() {
    return <PersonalPlanLandingPageFeature />;
}

PersonalPlanLandingPage.getLayout = PersonalPlanLandingPageFeature.getLayout;
